import Footer1 from "../../../components/footer/Footer1";
import Header1 from "../../../components/headers/Header1";
import Properties4 from "../../../components/properties/Properties4";
import React from "react";

import MetaComponent from "../../../components/common/MetaComponent";

// const metadata = {
//   title: "Sedebar Grid Property || Homelengo - Real Estate Reactjs Template",
//   description: "Homelengo - Real Estate Reactjs Template",
// };

export default function SidebarGridPage() {
  const pageUrl = typeof window !== "undefined" ? window.location.href : "";

  const [Title, setTitle] = React.useState("");
  const [Description, setDescription] = React.useState("");
  const [Keywords, setKeywords] = React.useState("");
  const [MetaImage, setMetaImage] = React.useState("");

  const metadata = {
    title: Title,
    description: Description,
    keywords: Keywords,
    url: pageUrl,
    siteName: "AskMeRealty",
    canonical: pageUrl,
    image: MetaImage,
  };

  return (
    <>
      <MetaComponent meta={metadata} />
      <Header1 />
      <Properties4 setTitle={setTitle} setDescription={setDescription} setKeywords={setKeywords} setMetaImage={setMetaImage} />
      <Footer1 />
    </>
  );
}
